<template>
  <Loading
    v-model:active="isLoading"
    :can-cancel="false"
    :is-full-page="true"
    :height="32"
    :width="32"
    color="#5e81f4"
    loader="spinner"
    :lock-scroll="true"
    :z-index="10000"
  >
    <template #before>
      <p class="loading-text">読み込み中</p>
    </template>
  </Loading>
</template>

<script setup>
import Loading from 'vue-loading-overlay';
import { computed } from 'vue';
import { useStore } from 'vuex';
import 'vue-loading-overlay/dist/css/index.css';

const store = useStore();
const isLoading = computed(() => store.getters['common/isLoading']);
</script>

<style scoped>
.loading-text {
  transform: translateX(-18px);
}
</style>